import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Hero = makeShortcode("Hero");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Hero slots="heading, title" mdxType="Hero" />
    <h1 {...{
      "id": "adobe-io-runtime-developer-guide"
    }}>{`Adobe I/O Runtime Developer Guide`}</h1>
    <p>{`This documentation provides an overview of Adobe I/O Runtime as well as guides, reference documentation, and tools to help you begin developing your own integrations. `}</p>
    <h2 {...{
      "id": "contents"
    }}>{`Contents`}</h2>
    <p><a parentName="p" {...{
        "href": "guides/index.md"
      }}>{`Quickstart guide:`}</a>{` A one-page guide to help you quickly get started with Adobe I/O Runtime.`}</p>
    <p><a parentName="p" {...{
        "href": "guides/overview/index.md"
      }}>{`Overview`}</a></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/overview/what_is_runtime.md"
        }}>{`What is Adobe I/O Runtime`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/overview/usecases.md"
        }}>{`Use Cases for Adobe I/O Runtime`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/overview/howitworks.md"
        }}>{`How Adobe I/O Runtime Works`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/overview/entities.md"
        }}>{`Adobe I/O Runtime Entities`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/overview/getting_access.md"
        }}>{`Getting Access`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "guides/getting-started/index.md"
      }}>{`Getting Started`}</a></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/getting-started/setup.md"
        }}>{`Setting up Your Environment`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/getting-started/deploy.md"
        }}>{`Deploying your First Adobe I/O Runtime Function`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/getting-started/activations.md"
        }}>{`Retrieve Action Invocation Results`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "guides/using/index.md"
      }}>{`Guides`}</a></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/using/creating_actions.md"
        }}>{`Creating Actions`}</a>{`: actions, web actions, invoking and managing, setting parameters`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/using/asynchronous_calls.md"
        }}>{`Asynchronous Calls`}</a>{`: how to execute long running async (non-blocking) calls`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/using/throughput_tuning.md"
        }}>{`Throughput Tuning`}</a>{`: how to maximize the number of action invocations`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/using/security_general.md"
        }}>{`Security Guide`}</a>{`: discover potential security issues and how to address them`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/using/securing_web_actions.md"
        }}>{`Securing Web Actions`}</a>{`: learn how to control the access to web actions`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/using/creating_rest_apis.md"
        }}>{`Creating REST APIs`}</a>{`: learn to create REST APIs from web actions`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/using/using_packages.md"
        }}>{`Using Packages`}</a>{`: Working with packages`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/using/logging_monitoring.md"
        }}>{`Logging & Monitoring`}</a>{`: learn how to troubleshoot your actions`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/using/debugging.md"
        }}>{`Debugging`}</a>{`: advanced debugging for Node.js actions`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/using/system_settings.md"
        }}>{`System Settings`}</a>{`: see the system settings and constraints `}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/using/ci-cd_pipeline.md"
        }}>{`CI/CD Pipeline`}</a>{`: understand the tools you have to create a CI/CD Pipeline`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "guides/reference/index.md"
      }}>{`Reference Documentation`}</a></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/reference/cli_use.md"
        }}>{`aio CLI`}</a>{`: how to use aio CLI`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/reference/wsk_use.md"
        }}>{`wsk CLI`}</a>{`: how to use wsk CLI`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/reference/environment_variables.md"
        }}>{`Environment Variables`}</a>{`: what environment variables do you have access to`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/reference/multiple_regions.md"
        }}>{`Multiple Regions`}</a>{`: where we run your actions`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/reference/prepackages.md"
        }}>{`Pre-installed Packages`}</a>{`: what packages are pre-installed `}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/reference/runtimes.md"
        }}>{`Runtimes`}</a>{`: details about the available runtimes`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/reference/api_ref.md"
        }}>{`API Reference`}</a>{`: I/O Management API`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/reference/triggersrules.md"
        }}>{`Triggers & Rules`}</a>{`: working with triggers and rules`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/reference/sequences_compositions.md"
        }}>{`Sequences & Compositions`}</a>{`: orchestrating actions`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/reference/packages.md"
        }}>{`Packages`}</a>{`: working with packages`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/reference/feeds.md"
        }}>{`Feeds`}</a>{`: working with feeds`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "guides/tools/index.md"
      }}>{`Tools`}</a></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/tools/cli_install.md"
        }}>{`aio CLI`}</a>{` - this tool helps you manage your namespaces and the authentication for the wsk CLI`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/tools/wsk_install.md"
        }}>{`wsk CLI`}</a>{` - this tool is the main interface for managing your actions/packages/rules/triggers and getting access to activation results/errors/logs`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "guides/tools/wskdeploy_install.md"
        }}>{`wskdeploy CLI`}</a>{` - this tool helps you deploy multiple actions and packages`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "support/index.md"
      }}>{`Resources and Support`}</a></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "support/faq.md"
        }}>{`FAQ`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      